import graphQLClient from './graphQLClient';
import { EDITOR_SESSION_LINK } from './graphql/hosting';

// Mints a single-use v2 editor entry URL server-side and opens it in a new
// tab (billing-portal pattern) — the dashboard stays where the user left it.
// The tab is opened synchronously inside the click gesture and pointed at the
// minted link when it arrives; window.open after the await would be eaten by
// popup blockers. Returns false when the backend refuses (not a v2 blog,
// feature off) so callers can fall back or show a message.
export default function openV2Editor(blogId) {
  const win = typeof window === 'undefined' ? null : window.open('', '_blank');
  return graphQLClient(EDITOR_SESSION_LINK, { blogId })
    .then(res => {
      if (!res?.editorSessionLink) {
        if (win) win.close();
        return false;
      }
      if (win) win.location.href = res.editorSessionLink;
      else window.location.href = res.editorSessionLink;
      return true;
    })
    .catch(err => {
      if (win) win.close();
      throw err;
    });
}
